module.exports = __webpack_public_path__ + "img/background_c4-2-1.785b2e66.jpg";